import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { ContentfulHeader } from "./../../components/ContentfulHeader";
import { Search, List } from "semantic-ui-react";
import treatmentItems from "../../../cms/treatment/treatment-lite.json";
import { Link } from "react-router";
import { ProgressiveText } from "../../components/ProgressiveText";
const withSlug = (items) => items.map(item => (Object.assign(Object.assign({}, item), { slug: item.loc.split("/").pop() })));
const TreatmentMenu = () => {
    const [searchTerm, setSearchTerm] = React.useState("");
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const filteredTreatments = useMemo(() => {
        if (!searchTerm)
            return withSlug(treatmentItems);
        const lowerSearchTerm = searchTerm.toLowerCase();
        return withSlug(treatmentItems).filter(item => item.title.toLowerCase().includes(lowerSearchTerm));
    }, [searchTerm]);
    const alphabeticallyGroupedTreatments = useMemo(() => {
        const grouped = {};
        withSlug(treatmentItems).forEach(item => {
            const firstLetter = item.title.trimStart().charAt(0).toUpperCase();
            if (!grouped[firstLetter]) {
                grouped[firstLetter] = [];
            }
            grouped[firstLetter].push(item);
        });
        return grouped;
    }, []);
    return (_jsxs("main", { children: [_jsx(ContentfulHeader, { title: "Treatments", desc: "InstantScripts offers a range of treatments to help you manage your health.", padding: "px-6 pb-10 pt-12 md:px-0 mx-auto" }), _jsxs("div", { className: "md:w-[700px] lg:w-[744px] mx-auto py-8 ", children: [_jsx("div", { className: "bg-white p-6", children: _jsx(Search, { className: "w-full  [&_input]:!rounded-full", open: false, input: {
                                fluid: true,
                                autoComplete: "false",
                                iconPosition: "left",
                            }, onSearchChange: handleSearchChange, value: searchTerm, placeholder: "Search for condition", fluid: true }) }), searchTerm !== "" ? (_jsx("div", { className: "mt-6 bg-white px-6 py-12", children: filteredTreatments.length === 0 ? (_jsx("div", { className: "text-center text-gray-500", children: "No treatments found." })) : (_jsx(List, { divided: true, relaxed: true, children: filteredTreatments.map(item => (_jsx(ListItem, { item: item }, item.slug))) })) })) : (_jsx("div", { className: "mt-6 flex flex-col gap-6 bg-white py-12", children: Object.keys(alphabeticallyGroupedTreatments)
                            .sort()
                            .map(letter => (_jsxs("div", { children: [_jsx("h2", { className: "text-xl font-semibold mb-4 mx-6", children: letter }), _jsx(List, { divided: true, relaxed: true, children: alphabeticallyGroupedTreatments[letter].map(item => (_jsx(ListItem, { item: item }, item.slug))) })] }, letter))) }))] })] }));
};
const formatTitle = (title) => {
    return title
        .replace(/Treatment\s*/i, "")
        .replace(/Online\s*/i, "")
        .trim();
};
const ListItem = ({ item }) => {
    return (_jsx(List.Item, { className: " hover:bg-is2-blue-50 !p-6", children: _jsx(Link, { to: `/treatment/${item.slug}`, children: _jsxs(List.Content, { children: [_jsx("li", { className: "text-is2_lg text-is2-gray-800 hover:text-is2-gray-600 cursor-pointer !mt-0", children: formatTitle(item.title) }), _jsx(ProgressiveText, { richText: item.description, expandText: "Read more", expandComponentType: "link" })] }) }) }, item.slug));
};
export default TreatmentMenu;
